import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { getfresherTimeline, getExperienceTimeline } from '../service/RecruiterApi';
// import Loader from '../../StaticComponent/Loader';

function CandidateTimeline(props) {
    const [timelineData, setTimelineData] = useState([]);
    const [isLoading, setIsLoading] = React.useState(true);

    useEffect(() => {
        loadData();
    }, []);

    let loadData = async () => {
        
        let resp;
        if (props.experience == 'Fresher') {
            setIsLoading(false);
            resp = await getfresherTimeline({ candidate_id: props.candidate_id });
           
            setIsLoading(true);
        } else if (props.experience == 'Experienced') {
            setIsLoading(false);
            resp = await getExperienceTimeline({ candidate_id: props.candidate_id });
            setIsLoading(true);
           
        }
        setTimelineData(resp.data.data);
    };



    let bindTimeline = () => {
        try {
            if (timelineData?.length == 0) {
                return (
                    <div>
                        <div className="row justify-content-center">
                            <img
                                src="/Images/nodatafound.png"
                                alt="nodatafound"
                                className="nofeedbackimg-sty"
                                style={{ height: '500px', width: '750px' }}
                            ></img>
                            <h2 className="semibold-text font-25 text-center margin-negative">No Timelines Found!</h2>
                        </div>
                    </div>
                );
            } else {
                return timelineData.map((obj, index) => {
                    
                    if (obj.icon_category === 'Initiated' || obj.icon_category === 'Approved') {
                       

                        return (
                            <li key={index} className="recruit-timeline-panel">
                                <div className="row align-items-center">
                                    <div className="col-md-2 text-end">
                                        <div className="recruit-timeline-date font-13 interview-gray-color regular-text">
                                            {moment(obj.created_at).format('ll')}
                                        </div>
                                        <div className="recruit-timeline-time font-13 interview-gray-color regular-text">
                                            {moment(obj.created_at).format('LT')}
                                        </div>
                                    </div>
                                    <div className="col-md-1">
                                        <div
                                            className={
                                                obj.icon_category === 'Approved'
                                                    ? `timelinebubble timelinestatus-orange`
                                                    : `timelinebubble timelinestatus-green`
                                            }
                                        >
                                            <img
                                                src={`/Images/Initiated-recruitment.svg`}
                                                alt="Interview Feedback Icon"
                                                className="img-fluid"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-8">
                                        <p className="font-15 m-0 regular-text ">
                                            <span className="interview-gray-color">{obj.audit_reason}</span> 
                                        </p>
                                    </div>
                                </div>
                            </li>
                        );
                    }
                    if (obj.icon_category === 'Hired') {
                        
                        return (
                            <li key={index} className="recruit-timeline-panel">
                                <div className="row align-items-center">
                                    <div className="col-md-2 text-end">
                                        <div className="recruit-timeline-date font-13 interview-gray-color regular-text">
                                            {moment(obj.created_at).format('ll')}
                                        </div>
                                        <div className="recruit-timeline-time font-13 interview-gray-color regular-text">
                                            {moment(obj.created_at).format('LT')}
                                        </div>
                                    </div>
                                    <div className="col-md-1">
                                        <div className="timelinebubble timelinestatus-green">
                                            <img
                                                src={`/Images/${obj.icon_category + `-recruitment`}.svg`}
                                                alt="Interview Feedback Icon"
                                                className="img-fluid"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-8">
                                        <p className="font-15 m-0 regular-text ">
                                            {obj.audit_reason}
                                           
                                        </p>
                                    </div>
                                </div>
                            </li>
                        );
                    }
                    if (obj.icon_category === 'Feedback') {
                      

                        return (
                            <li key={index} className="recruit-timeline-panel">
                                <div className="row align-items-center">
                                    <div className="col-md-2 text-end">
                                        <div className="recruit-timeline-date font-13 interview-gray-color regular-text">
                                            {moment(obj.created_at).format('ll')}
                                        </div>
                                        <div className="recruit-timeline-time font-13 interview-gray-color regular-text">
                                            {moment(obj.created_at).format('LT')}
                                        </div>
                                    </div>
                                    <div className="col-md-1">
                                        <div className="timelinebubble timelinestatus-green">
                                            <img
                                                src={`/Images/${obj.icon_category + `-recruitment`}.svg`}
                                                alt="Interview Feedback Icon"
                                                className="img-fluid"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-8">
                                        <p className="font-15 m-0 regular-text ">
                                            <span className="interview-gray-color">{obj.audit_reason}</span>
                                           
                                        </p>
                                    </div>
                                </div>
                            </li>
                        );
                    }
                    if (obj.icon_category === 'Moved') {
                        
                        

                        return (
                            <li key={index} className="recruit-timeline-panel">
                                <div className="row align-items-center">
                                    <div className="col-md-2 text-end">
                                        <div className="recruit-timeline-date font-13 interview-gray-color regular-text">
                                            {moment(obj.created_at).format('ll')}
                                        </div>
                                        <div className="recruit-timeline-time font-13 interview-gray-color regular-text">
                                            {moment(obj.created_at).format('LT')}
                                        </div>
                                    </div>
                                    <div className="col-md-1">
                                        <div className="timelinebubble timelinestatus-green">
                                            <img
                                                src={`/Images/${obj.icon_category + `-recruitment`}.svg`}
                                                alt="Interview Feedback Icon"
                                                className="img-fluid"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-8">
                                        <p className="font-15 m-0 regular-text ">
                                            <span className="interview-gray-color">{obj.audit_reason}</span>
                                           
                                        </p>
                                    </div>
                                </div>
                            </li>
                        );
                    }
                    if (obj.icon_category === 'Meeting') {
                        
                        try {
                            //    let first = obj.audit_reason.split('Interview scheduled for')[0];
                            //    let job = obj.audit_reason.split('Interview scheduled for')[1].split('job -')[0];
                            //    let round = obj.audit_reason.split('Interview scheduled for')[1].split('job -')[1].split('stage with')[0];
                            //    let toName = obj.audit_reason.split('stage with')[1].split(' at ')[0];
                            //    let time = obj.audit_reason.split('stage with')[1].split(' at ')[1].split('for')[0];
                            //    let etatime = obj.audit_reason.split('stage with')[1].split(' at ')[1].split('for')[1].split(' by')[0];
                            //    let byPerson = obj.audit_reason.split('stage with')[1].split(' at ')[1].split('for')[1].split(' by')[1];
                            return (
                                <li key={index} className="recruit-timeline-panel">
                                    <div className="row align-items-center">
                                        <div className="col-md-2 text-end">
                                            <div className="recruit-timeline-date font-13 interview-gray-color regular-text">
                                                {moment(obj.created_at).format('ll')}
                                            </div>
                                            <div className="recruit-timeline-time font-13 interview-gray-color regular-text">
                                                {moment(obj.created_at).format('LT')}
                                            </div>
                                        </div>
                                        <div className="col-md-1">
                                            <div className="timelinebubble timelinestatus-green">
                                                <img
                                                    src={`/Images/${obj.icon_category + `-recruitment`}.svg`}
                                                    alt="Interview Feedback Icon"
                                                    className="img-fluid"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-8">
                                            <p className="font-15 m-0 regular-text ">
                                                {/* {first} */}
                                                <span className="interview-gray-color">{obj.audit_reason} </span>
                                                {/* {job} <span className="interview-gray-color"> job -</span> {round}{' '} */}
                                                {/* <span className="interview-gray-color">stage with </span>
                                                {toName}
                                                <span className="interview-gray-color"> at </span>
                                                {time} <span className="interview-gray-color">for</span> {etatime}
                                                <span className="interview-gray-color"> by </span>
                                                {byPerson} */}
                                            </p>
                                        </div>
                                    </div>
                                </li>
                            );
                        } catch (err) {
                            
                        }
                    }
                    if (obj.icon_category === 'Added to') {
                        // obj.icon_category = obj.icon_category === 'Added to' ? 'Meeting' : obj.icon_category
                        
                        return (
                            <li key={index} className="recruit-timeline-panel">
                                <div className="row align-items-center">
                                    <div className="col-md-2 text-end">
                                        <div className="recruit-timeline-date font-13 interview-gray-color regular-text">
                                            {moment(obj.created_at).format('ll')}
                                        </div>
                                        <div className="recruit-timeline-time font-13 interview-gray-color regular-text">
                                            {moment(obj.created_at).format('LT')}
                                        </div>
                                    </div>
                                    <div className="col-md-1">
                                        <div className="timelinebubble timelinestatus-green">
                                            <img
                                                src={`/Images/Meeting-recruitment.svg`}
                                                alt="Interview Feedback Icon"
                                                className="img-fluid"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-8">
                                        <p className="font-15 m-0 regular-text ">
                                            <span className="interview-gray-color">{obj.audit_reason}</span>
                                        </p>
                                    </div>
                                </div>
                            </li>
                        );
                    }
                });
            }
        } catch (e) {}
    };

    return (
        <div>
            <div className="row">
                <div className="col-md-12 mt-4">
                    <div className="card border-0">
                        <div className="card-body pe-4 py-4">
                            <ul className="list-unstyled">
                                {/* <li className="recruit-timeline-panel">
                                             <div className="row align-items-center">
                                                  <div className="col-md-2 text-end">
                                                       <div className="recruit-timeline-date font-13 interview-gray-color regular-text">April 27, 2022</div>
                                                       <div className="recruit-timeline-time font-13 interview-gray-color regular-text">8.42 PM</div>
                                                  </div>
                                                  <div className="col-md-1">
                                                       <div className="timelinebubble timelinestatus-purple">
                                                            <img src="/Images/timeline-purple.svg" alt="Timeline Icon" className="img-fluid" />
                                                       </div>
                                                  </div>
                                                  <div className="col-md-8">
                                                       <p className="font-15 m-0 regular-text">
                                                            <span className="interview-gray-color">Added to</span> Sample Job Posting job, Sales <span className="interview-gray-color">department by</span> Manikandan M
                                                            Source: <span className="interview-gray-color">Direct,</span> Source Category: <span className="interview-gray-color">Portal</span>
                                                       </p>
                                                  </div>
                                             </div>
                                        </li> */}
                                {bindTimeline()}
                                {/* <li className="recruit-timeline-panel">
                                             <div className="row align-items-center">
                                                  <div className="col-md-2 text-end">
                                                       <div className="recruit-timeline-date font-13 interview-gray-color regular-text">April 27, 2022</div>
                                                       <div className="recruit-timeline-time font-13 interview-gray-color regular-text">8.42 PM</div>
                                                  </div>
                                                  <div className="col-md-1">
                                                       <div className="timelinebubble timelinestatus-green">
                                                            <img src="/Images/interviewfeedback.svg" alt="Interview Feedback Icon" className="img-fluid" />
                                                       </div>
                                                  </div>
                                                  <div className="col-md-8">
                                                       <p className="font-15 m-0 regular-text "><span className="interview-gray-color">Added to</span> Sample Job Posting job, Sales <span className="interview-gray-color">department by</span> Manikandan M
                                                            Source: <span className="interview-gray-color">Direct,</span> Source Category: <span className="interview-gray-color">Portal</span></p>
                                                  </div>
                                             </div>
                                        </li>
                                        <li className="recruit-timeline-panel">
                                             <div className="row align-items-center">
                                                  <div className="col-md-2 text-end">
                                                       <div className="recruit-timeline-date interview-gray-color font-13 regular-text">April 27, 2022</div>
                                                       <div className="recruit-timeline-time interview-gray-color font-13 regular-text">8.42 PM</div>
                                                  </div>
                                                  <div className="col-md-1">
                                                       <div className="timelinebubble timelinestatus-green">
                                                            <img src="/Images/time.svg" alt="Candidate Approval Icon" className="img-fluid" />
                                                       </div>
                                                  </div>
                                                  <div className="col-md-8">
                                                       <p className="font-15 m-0 regular-text"><span className="interview-gray-color">Added to</span> Sample Job Posting job, Sales <span className="interview-gray-color">department by</span> Manikandan M
                                                            Source: <span className="interview-gray-color">Direct,</span> Source Category: <span className="interview-gray-color">Portal</span></p>
                                                  </div>
                                             </div>
                                        </li>
                                        <li className="recruit-timeline-panel">
                                             <div className="row align-items-center">
                                                  <div className="col-md-2 text-end">
                                                       <div className="recruit-timeline-date font-13 regular-text">April 27, 2022</div>
                                                       <div className="recruit-timeline-time font-13 regular-text">8.42 PM</div>
                                                  </div>
                                                  <div className="col-md-1">
                                                       <div className="timelinebubble timelinestatus-orange">
                                                            <img src="/Images/offerapproval-orange.svg" alt="Offer Approval Icon" className="img-fluid" />
                                                       </div>
                                                  </div>
                                                  <div className="col-md-8">
                                                       <p className="font-15 m-0 regular-text"><span className="interview-gray-color">Added to</span> Sample Job Posting job, Sales <span className="interview-gray-color">department by</span> Manikandan M
                                                            Source: <span className="interview-gray-color">Direct,</span> Source Category: <span className="interview-gray-color">Portal</span></p>
                                                  </div>
                                             </div>
                                        </li>
                                        <li className="recruit-timeline-panel">
                                             <div className="row align-items-center">
                                                  <div className="col-md-2 text-end">
                                                       <div className="recruit-timeline-date font-13 regular-text ">April 27, 2022</div>
                                                       <div className="recruit-timeline-time font-13 regular-text">8.42 PM</div>
                                                  </div>
                                                  <div className="col-md-1">
                                                       <div className="timelinebubble timelinestatus-green">
                                                            <img src="/Images/candidatehired.svg" alt="Candidate Hired Icon" className="img-fluid" />
                                                       </div>
                                                  </div>
                                                  <div className="col-md-8">
                                                       <p className="font-15 m-0 regular-text"><span className="interview-gray-color">Added to</span> Sample Job Posting job, Sales <span className="interview-gray-color">department by</span> Manikandan M
                                                            Source: <span className="interview-gray-color">Direct,</span> Source Category: <span className="interview-gray-color">Portal</span></p>
                                                  </div>
                                             </div>
                                        </li> */}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CandidateTimeline;
